import React from 'react';
import FaiBox from "../../../MuiComponents/FaiBox";
import {Icon, Stack, TextField} from "@mui/material";
import FaiButton from "../../../MuiComponents/FaiButton";
import Strip from "../../../components/Strip";
import FaiSelect from "../../../MuiComponents/FaiSelect";

export interface FeedbackFilters {
    search?: string;
    rating?: number;
}

interface HeaderBarProps {
    filters: FeedbackFilters;
    onFilterChange: (filters: FeedbackFilters) => void;
}

const RATING_OPTIONS = [5, 4, 3, 2, 1].map((n) => ({value: n, label: `${n} star${n === 1 ? '' : 's'}`}));

// Filters the reviews shown below as the merchant types or picks a rating.
function HeaderBar({filters, onFilterChange}: HeaderBarProps) {
    return (
        <>
            <FaiBox>
                <Strip>
                    <FaiBox p={"10px 10px"}>
                        <FaiBox display={"flex"} alignItems={"center"} justifyContent="space-between">
                            <FaiBox>
                                <Stack spacing={1} direction="row">
                                    <TextField
                                        size="small"
                                        sx={{minWidth: 300}}
                                        placeholder="Search product, customer or review"
                                        value={filters.search ?? ""}
                                        onChange={(e) => onFilterChange({...filters, search: e.target.value})}
                                        InputProps={{endAdornment: <Icon fontSize={"small"}>search</Icon>}}
                                    />
                                    <FaiSelect
                                        placeholder="Rating"
                                        options={RATING_OPTIONS}
                                        value={RATING_OPTIONS.find((o) => o.value === filters.rating) ?? null}
                                        onChange={(option: any) => onFilterChange({...filters, rating: option?.value})}
                                    />
                                </Stack>
                            </FaiBox>
                            <FaiBox display={"flex"} alignItems={"center"} justifyContent="space-between">
                                <FaiBox>
                                    <Stack spacing={1} direction="row">
                                        <FaiButton sx={{
                                            padding: "7px 12px !important",
                                            height: "34px",
                                            minHeight: 0

                                        }} variant="contained" color="dark" onClick={() => onFilterChange({})}>
                                            Reset
                                        </FaiButton>
                                    </Stack>
                                </FaiBox>
                            </FaiBox>
                        </FaiBox>
                    </FaiBox>
                </Strip>
            </FaiBox>
        </>
    )
        ;
}

export default HeaderBar;
